// import React, { useMemo, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { type FormikProps } from 'formik';
// import Loading from '@components/Shared/Loader/Loading';
// import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import { NumericFormat } from 'react-number-format';
// import useGetExpenseCategoryItemsList from '@hooks/Finance/Expense/useGetExpenseCategoryItemsList';

// const MAX_FILE_SIZE_MB = 1; // ✅ غيّرها
// const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// const formatMB = (bytes: number) => (bytes / 1024 / 1024).toFixed(2);

// interface LinesProps {
//   formik: FormikProps<any>;
//   NotEditable: boolean;
//   maxTableHeight?: string;
// }

// type VatMode = 'STANDARD15' | 'ZERO0' | 'CUSTOM';

// const ApExpenseLines: React.FC<LinesProps> = ({ formik, NotEditable, maxTableHeight = '400px' }) => {
//   // const { values, errors, touched, setFieldValue } = formik;
//   const { values, errors, touched, setFieldValue, setFieldError, setFieldTouched } = formik;

//   const { i18n, t } = useTranslation();

//   const {
//     ApExpenseCategoryItemsList: data,
//     loading,
//     error
//   } = useGetExpenseCategoryItemsList({
//     expenseCategoryId: values.expenseCategoryId ?? ''
//   });

//   // ✅ 3 خيارات: قياسي / صفري / مخصص
//   const [vatMode, setVatMode] = useState<VatMode>('CUSTOM');

//   // Helpers
//   const toNum = (v: any) => {
//     const n = Number(v);
//     return Number.isFinite(n) ? n : 0;
//   };

//   const round2 = (n: number) => Math.round((toNum(n) + Number.EPSILON) * 100) / 100;

//   const format2 = (n: number) =>
//     new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(toNum(n));

//   /**
//    * ✅ قاعدة الإرسال دائمًا:
//    * amount = NET
//    * vat    = VAT
//    *
//    * - STANDARD15: المستخدم يدخل "GROSS" (شامل) => نحسب NET/VAT ونخزنهم
//    * - ZERO0: VAT=0 و amount = المدخل
//    * - CUSTOM: المستخدم يدخل NET في خانة القيمة، ويدخل VAT يدويًا في خانة الضريبة
//    */
//   const applyAmountInput = (index: number, inputValue: number) => {
//     if (vatMode === 'CUSTOM') {
//       // CUSTOM: القيمة = NET (لا نغير VAT هنا)
//       setFieldValue(`apExpenseLinesList[${index}].amount`, round2(inputValue));
//       setFieldValue(`apExpenseLinesList[${index}].isIncludeVat`, false);
//       return;
//     }

//     if (vatMode === 'ZERO0') {
//       setFieldValue(`apExpenseLinesList[${index}].amount`, round2(inputValue));
//       setFieldValue(`apExpenseLinesList[${index}].vat`, 0);
//       setFieldValue(`apExpenseLinesList[${index}].isIncludeVat`, false);
//       return;
//     }

//     // STANDARD15: المدخل يعتبر GROSS
//     const rate = 0.15;
//     const gross = inputValue;
//     const net = gross / (1 + rate);
//     const vat = gross - net;

//     setFieldValue(`apExpenseLinesList[${index}].amount`, round2(net)); // ✅ NET للإرسال
//     setFieldValue(`apExpenseLinesList[${index}].vat`, round2(vat));    // ✅ VAT للإرسال
//     setFieldValue(`apExpenseLinesList[${index}].isIncludeVat`, true);
//   };

//   const applyVatInputCustom = (index: number, vatValue: number) => {
//     // CUSTOM فقط
//     setFieldValue(`apExpenseLinesList[${index}].vat`, round2(vatValue));
//   };

//   /**
//    * ✅ عند تغيير الوضع:
//    * - STANDARD15: نخلي الإجمالي (gross) ثابت قدر الإمكان ثم نعيد توزيع NET/VAT
//    * - ZERO0: VAT=0 و NET = gross الحالي
//    * - CUSTOM: نخلي NET = NET الحالي (بدون تغيير) و VAT نخليه كما هو (قابل للتعديل)
//    */
//   const recalcAllLines = (nextMode: VatMode) => {
//     const list = Array.isArray(values.apExpenseLinesList) ? values.apExpenseLinesList : [];

//     const updated = list.map((ln: any) => {
//       const net = toNum(ln.amount);
//       const vat = toNum(ln.vat);
//       const gross = net + vat;

//       if (nextMode === 'ZERO0') {
//         return { ...ln, amount: round2(gross), vat: 0, isIncludeVat: false };
//       }

//       if (nextMode === 'CUSTOM') {
//         // اجعل القيمة صافي، والضريبة تبقى كما هي وتصبح قابلة للتعديل
//         return { ...ln, amount: round2(net), isIncludeVat: false };
//       }

//       // STANDARD15
//       const rate = 0.15;
//       const newNet = gross / (1 + rate);
//       const newVat = gross - newNet;
//       return { ...ln, amount: round2(newNet), vat: round2(newVat), isIncludeVat: true };
//     });

//     setFieldValue('apExpenseLinesList', updated);
//   };

//   const totals = useMemo(() => {
//     const list = values.apExpenseLinesList || [];
//     const subtotal = list.reduce((sum: number, line: any) => sum + (toNum(line.amount) || 0), 0); // NET
//     const vat = list.reduce((sum: number, line: any) => sum + (toNum(line.vat) || 0), 0);

//     return {
//       subtotal: format2(subtotal),
//       vat: format2(vat),
//       total: format2(subtotal + vat)
//     };
//   }, [values.apExpenseLinesList]);

//   const handleLineChange = (index: number, field: string, value: any) => {
//     setFieldValue(`apExpenseLinesList[${index}].${field}`, value);
//   };

//   const handleDeleteLine = (index: number) => {
//     const updatedLines = values.apExpenseLinesList.filter((_: any, i: number) => i !== index);
//     setFieldValue('apExpenseLinesList', updatedLines);
//   };

//   const getLineError = (index: number, field: string) => {
//     const lineErrors = (errors.apExpenseLinesList as any) || [];
//     const lineTouched = (touched.apExpenseLinesList as any) || [];
//     return lineTouched?.[index]?.[field] && lineErrors?.[index]?.[field] ? lineErrors[index][field] : null;
//   };

//   const triggerPick = (index: number) => {
//     if (NotEditable) return;
//     document.getElementById(`file-${index}`)?.click();
//   };

//   const renderAttachmentCell = (line: any, index: number) => {
//     const hasNewFile = line?.fileAttachment instanceof File;
//     const hasExisting = !!line?.existingAttachment;

//     return (
//       <td className='align-middle text-center'>
//         <input
//           id={`file-${index}`}
//           type='file'
//           hidden
//           disabled={NotEditable}
//           onChange={e => {
//             const f = e.currentTarget.files?.[0] || null;
//             if (!f) return;

//             handleLineChange(index, 'fileAttachment', f);
//             handleLineChange(index, 'existingAttachment', null);
//             e.currentTarget.value = '';
//           }}
//         />

//         <div className='d-flex justify-content-center'>
//           {hasNewFile ? (
//             <div
//               className='d-flex align-items-center bg-theme bg-opacity-10 text-theme px-2 py-1 rounded border border-theme border-opacity-25'
//               style={{ maxWidth: '220px' }}
//             >
//               <i className='fas fa-file-alt me-2'></i>

//               <OverlayTrigger overlay={<Tooltip>{line.fileAttachment.name}</Tooltip>}>
//                 <span
//                   className='text-truncate small fw-bold flex-grow-1 cursor-pointer'
//                   style={{ fontSize: '0.75rem' }}
//                   onClick={() => triggerPick(index)}
//                 >
//                   {line.fileAttachment.name}
//                 </span>
//               </OverlayTrigger>

//               {!NotEditable && (
//                 <button
//                   type='button'
//                   className='btn btn-link btn-sm text-danger p-0 ms-2'
//                   onClick={() => handleLineChange(index, 'fileAttachment', null)}
//                 >
//                   <i className='fas fa-times-circle'></i>
//                 </button>
//               )}
//             </div>
//           ) : hasExisting ? (
//             <div
//               className='d-flex align-items-center bg-secondary bg-opacity-10 px-2 py-1 rounded border border-secondary border-opacity-25'
//               style={{ maxWidth: '220px' }}
//             >
//               <i className='fas fa-paperclip me-2'></i>

//               <a
//                 href={line.existingAttachment.filePath}
//                 target='_blank'
//                 rel='noreferrer'
//                 className='text-truncate small fw-bold flex-grow-1'
//                 style={{ fontSize: '0.75rem', textDecoration: 'none', color: 'inherit' }}
//                 title={line.existingAttachment.fileName}
//               >
//                 {line.existingAttachment.fileName}
//               </a>

//               {!NotEditable && (
//                 <button type='button' className='btn btn-outline-theme btn-sm ms-2' onClick={() => triggerPick(index)}>
//                   {t('استبدال')}
//                 </button>
//               )}
//             </div>
//           ) : (
//             <button
//               type='button'
//               className='btn btn-outline-theme btn-sm d-flex align-items-center gap-2 px-3'
//               onClick={() => triggerPick(index)}
//               disabled={NotEditable}
//             >
//               <i className='fas fa-paperclip'></i>
//               {t('أرفق ملف')}
//             </button>
//           )}
//         </div>
//       </td>
//     );
//   };

//   return (
//     <Loading loading={loading} error={error} Type='Dots'>
//       <div className='card-header d-flex justify-content-between align-items-center   bg-opacity-50 py-3'>
//         <h6 className='mb-0 fw-bold '>
//           <i className='fas fa-list-ol me-2 text-theme'></i>
//           {t('تفاصيل بنود المصروفات')}
//         </h6>

//         <div className='d-flex gap-3 align-items-center flex-wrap'>
//           <span className='badge bg-theme bg-opacity-10 text-theme border border-theme border-opacity-25 d-flex align-items-center px-3'>
//             {t('عدد البنود')}: {(values.apExpenseLinesList || []).length}
//           </span>

//           {/* ✅ Select (3 خيارات) */}
//           <div className='d-flex align-items-center gap-2'>
//             <span className='small fw-bold text-muted'>{t('الضريبة')}:</span>
//             <Form.Select
//               size='sm'
//               disabled={NotEditable}
//               value={vatMode}
//               onChange={e => {
//                 const next = e.target.value as VatMode;
//                 setVatMode(next);
//                 recalcAllLines(next);
//               }}
//               style={{ width: 190 }}
//               className='border-theme border-opacity-25'
//             >
//               <option value='STANDARD15'>{t('قياسي 15%')}</option>
//               <option value='ZERO0'>{t('صفري 0%')}</option>
//               <option value='CUSTOM'>{t('مخصص')}</option>
//             </Form.Select>
//           </div>

//           <button
//             hidden={NotEditable}
//             type='button'
//             className='btn btn-theme btn-sm px-3 shadow-sm'
//             onClick={() =>
//               setFieldValue('apExpenseLinesList', [
//                 ...(values.apExpenseLinesList || []),
//                 {
//                   id: '',
//                   expenseCategoryItemId: '',
//                   description: '',
//                   amount: 0, // ✅ NET دائمًا للإرسال
//                   vat: 0,
//                   isIncludeVat: vatMode === 'STANDARD15',
//                   existingAttachment: null,
//                   fileAttachment: null
//                 }
//               ])
//             }
//           >
//             <i className='fas fa-plus-circle me-2'></i>
//             {t('إضافة بند')}
//           </button>
//         </div>
//       </div>

//       {(values.apExpenseLinesList || []).length > 0 && (
//         <div className='card-body p-3'>
//           <div className='bg-inverse bg-opacity-10 p-3 rounded-0'>
//             <div className='d-flex flex-wrap gap-4 justify-content-between'>
//               <div className='d-flex gap-2 align-items-center'>
//                 <span className='fw-bold'>{t('الإجمالي')}:</span>
//                 <span className='fw-bold'>{totals.subtotal}</span>
//               </div>
//               <div className='d-flex gap-2 align-items-center'>
//                 <span className='fw-bold'>{t('الضريبة')}:</span>
//                 <span className='fw-bold text-warning'>{totals.vat}</span>
//               </div>
//               <div className='d-flex gap-2 align-items-center'>
//                 <span className='fw-bold'>{t('الصافي')}:</span>
//                 <span className='text-theme fs-5 fw-bold'>{totals.total}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className='card-body p-0'>
//         {(values.apExpenseLinesList || []).length > 0 ? (
//           <div className='table-responsive'>
//             <div style={{ maxHeight: maxTableHeight, overflow: 'auto' }}>
//               <table className='table table-hover align-middle mb-0'>
//                 <thead className='table-actived fw-bold sticky-top' style={{ zIndex: 10 }}>
//                   <tr className='small text-muted'>
//                     <th className='text-center' style={{ width: '50px' }}>
//                       #
//                     </th>
//                     <th style={{ width: '20%' }}>{t('بند المصروف')}</th>
//                     <th style={{ width: '35%' }}>{t('الوصف')}</th>
//                     <th className='text-center' style={{ width: '12%' }}>
//                       {vatMode === 'STANDARD15' ? t('القيمة (شامل)') : t('القيمة')}
//                     </th>
//                     <th className='text-center' style={{ width: '12%' }}>
//                       {vatMode === 'CUSTOM' ? t('الضريبة (مخصص)') : t('الضريبة')}
//                     </th>
//                     <th className='text-center' style={{ width: '10%' }}>
//                       {t('المرفق')}
//                     </th>
//                     <th className='text-center' style={{ width: '8%' }}></th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {(values.apExpenseLinesList || []).map((line: any, index: number) => {
//                     const hasError = !!getLineError(index, 'expenseCategoryItemId') || !!getLineError(index, 'amount');

//                     // ✅ المخزن/المرسل دائمًا NET/VAT
//                     const netAmount = toNum(line.amount);
//                     const vatAmount = toNum(line.vat);
//                     const grossAmount = round2(netAmount + vatAmount); // ✅ عرض فقط

//                     return (
//                       <tr key={line.rowKey || index} className={hasError ? 'bg-danger bg-opacity-10' : ''}>
//                         <td className='text-center small fw-bold text-muted'>{index + 1}</td>

//                         <td>
//                           <Form.Select
//                             disabled={NotEditable}
//                             size='sm'
//                             className={`border-theme border-opacity-25 ${
//                               getLineError(index, 'expenseCategoryItemId') ? 'is-invalid' : ''
//                             }`}
//                             value={line.expenseCategoryItemId || ''}
//                             onChange={e => handleLineChange(index, 'expenseCategoryItemId', e.target.value)}
//                           >
//                             <option value=''>{t('اختر البند...')}</option>
//                             {data?.map((m: any) => (
//                               <option value={m.id} key={m.id}>
//                                 {i18n.language === 'en' ? m.name : m.name2}
//                               </option>
//                             ))}
//                           </Form.Select>
//                         </td>

//                         <td>
//                           <Form.Control
//                             disabled={NotEditable}
//                             size='sm'
//                             as='textarea'
//                             rows={1}
//                             className='border-theme border-opacity-25'
//                             value={line.description || ''}
//                             onChange={e => handleLineChange(index, 'description', e.target.value)}
//                             style={{ minHeight: '35px' }}
//                           />
//                         </td>

//                         {/* ✅ القيمة: في القياسي المستخدم يدخل شامل، في غيره NET */}
//                         <td>
//                           <NumericFormat
//                             disabled={NotEditable}
//                             value={vatMode === 'STANDARD15' ? grossAmount : netAmount}
//                             thousandSeparator=','
//                             className='form-control form-control-sm border-theme border-opacity-25 text-center fw-bold'
//                             onValueChange={v => {
//                               const input = v.floatValue || 0;
//                               applyAmountInput(index, input);
//                             }}
//                           />
//                         </td>

//                         {/* ✅ الضريبة: مخصص => Editable ، غيره => ReadOnly */}
//                         <td>
//                           <NumericFormat
//                             disabled={NotEditable || vatMode !== 'CUSTOM'}
//                             value={vatAmount}
//                             thousandSeparator=','
//                             className='form-control form-control-sm border-theme border-opacity-25 text-center'
//                             onValueChange={v => {
//                               const vv = v.floatValue || 0;
//                               applyVatInputCustom(index, vv);
//                             }}
//                           />
//                         </td>

//                         {renderAttachmentCell(line, index)}

//                         <td className='text-center'>
//                           <button
//                             type='button'
//                             className='btn btn-link btn-sm text-danger p-0'
//                             onClick={() => handleDeleteLine(index)}
//                             hidden={NotEditable}
//                           >
//                             <i className='fas fa-trash-alt'></i>
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         ) : (
//           <div className='card-body p-5 text-center'>
//             <div className='opacity-50 mb-3'>
//               <i className='fas fa-receipt fa-4x text-theme'></i>
//             </div>
//             <h5 className='text-muted'>{t('لا توجد مصروفات بعد')}</h5>
//             <p className='small text-muted mb-4'>{t('قم بإضافة البنود لتبدأ في تسجيل المصروفات')}</p>
//           </div>
//         )}
//       </div>
//     </Loading>
//   );
// };

// export default ApExpenseLines;

import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type FormikProps } from 'formik';
import Loading from '@components/Shared/Loader/Loading';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { NumericFormat } from 'react-number-format';
import useGetExpenseCategoryItemsList from '@hooks/Finance/Expense/useGetExpenseCategoryItemsList';
import ToastSwal from '@components/Shared/Alert/ToastSwal';

const MAX_FILE_SIZE_MB = 1; // ✅ غيّرها
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const formatMB = (bytes: number) => (bytes / 1024 / 1024).toFixed(2);

interface LinesProps {
  formik: FormikProps<any>;
  NotEditable: boolean;
  maxTableHeight?: string;
}

type VatMode = 'STANDARD15' | 'ZERO0' | 'CUSTOM';

const ApExpenseLines: React.FC<LinesProps> = ({ formik, NotEditable, maxTableHeight = '400px' }) => {
  // const { values, errors, touched, setFieldValue } = formik;
  const { values, errors, touched, setFieldValue, setFieldError, setFieldTouched } = formik;

  const { i18n, t } = useTranslation();

  const {
    ApExpenseCategoryItemsList: data,
    loading,
    error
  } = useGetExpenseCategoryItemsList({
    expenseCategoryId: values.expenseCategoryId ?? ''
  });

  // ✅ 3 خيارات: قياسي / صفري / مخصص
  const [vatMode, setVatMode] = useState<VatMode>('CUSTOM');

  // Helpers
  const toNum = (v: any) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const round2 = (n: number) => Math.round((toNum(n) + Number.EPSILON) * 100) / 100;

  const format2 = (n: number) =>
    new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(toNum(n));

  /**
   * ✅ قاعدة الإرسال دائمًا:
   * amount = NET
   * vat    = VAT
   *
   * - STANDARD15: المستخدم يدخل "GROSS" (شامل) => نحسب NET/VAT ونخزنهم
   * - ZERO0: VAT=0 و amount = المدخل
   * - CUSTOM: المستخدم يدخل NET في خانة القيمة، ويدخل VAT يدويًا في خانة الضريبة
   */
  const applyAmountInput = (index: number, inputValue: number) => {
    if (vatMode === 'CUSTOM') {
      // CUSTOM: القيمة = NET (لا نغير VAT هنا)
      setFieldValue(`apExpenseLinesList[${index}].amount`, round2(inputValue));
      setFieldValue(`apExpenseLinesList[${index}].isIncludeVat`, false);
      return;
    }

    if (vatMode === 'ZERO0') {
      setFieldValue(`apExpenseLinesList[${index}].amount`, round2(inputValue));
      setFieldValue(`apExpenseLinesList[${index}].vat`, 0);
      setFieldValue(`apExpenseLinesList[${index}].isIncludeVat`, false);
      return;
    }

    // STANDARD15: المدخل يعتبر GROSS
    const rate = 0.15;
    const gross = inputValue;
    const net = gross / (1 + rate);
    const vat = gross - net;

    setFieldValue(`apExpenseLinesList[${index}].amount`, round2(net)); // ✅ NET للإرسال
    setFieldValue(`apExpenseLinesList[${index}].vat`, round2(vat)); // ✅ VAT للإرسال
    setFieldValue(`apExpenseLinesList[${index}].isIncludeVat`, true);
  };

  const applyVatInputCustom = (index: number, vatValue: number) => {
    // CUSTOM فقط
    setFieldValue(`apExpenseLinesList[${index}].vat`, round2(vatValue));
  };

  /**
   * ✅ عند تغيير الوضع:
   * - STANDARD15: نخلي الإجمالي (gross) ثابت قدر الإمكان ثم نعيد توزيع NET/VAT
   * - ZERO0: VAT=0 و NET = gross الحالي
   * - CUSTOM: نخلي NET = NET الحالي (بدون تغيير) و VAT نخليه كما هو (قابل للتعديل)
   */
  const recalcAllLines = (nextMode: VatMode) => {
    const list = Array.isArray(values.apExpenseLinesList) ? values.apExpenseLinesList : [];

    const updated = list.map((ln: any) => {
      const net = toNum(ln.amount);
      const vat = toNum(ln.vat);
      const gross = net + vat;

      if (nextMode === 'ZERO0') {
        return { ...ln, amount: round2(gross), vat: 0, isIncludeVat: false };
      }

      if (nextMode === 'CUSTOM') {
        // اجعل القيمة صافي، والضريبة تبقى كما هي وتصبح قابلة للتعديل
        return { ...ln, amount: round2(net), isIncludeVat: false };
      }

      // STANDARD15
      const rate = 0.15;
      const newNet = gross / (1 + rate);
      const newVat = gross - newNet;
      return { ...ln, amount: round2(newNet), vat: round2(newVat), isIncludeVat: true };
    });

    setFieldValue('apExpenseLinesList', updated);
  };

  const totals = useMemo(() => {
    const list = values.apExpenseLinesList || [];
    const subtotal = list.reduce((sum: number, line: any) => sum + (toNum(line.amount) || 0), 0); // NET
    const vat = list.reduce((sum: number, line: any) => sum + (toNum(line.vat) || 0), 0);

    return {
      subtotal: format2(subtotal),
      vat: format2(vat),
      total: format2(subtotal + vat)
    };
  }, [values.apExpenseLinesList]);

  const handleLineChange = (index: number, field: string, value: any) => {
    setFieldValue(`apExpenseLinesList[${index}].${field}`, value);
  };

  const handleDeleteLine = (index: number) => {
    const updatedLines = values.apExpenseLinesList.filter((_: any, i: number) => i !== index);
    setFieldValue('apExpenseLinesList', updatedLines);
  };

  const getLineError = (index: number, field: string) => {
    const lineErrors = (errors.apExpenseLinesList as any) || [];
    const lineTouched = (touched.apExpenseLinesList as any) || [];
    return lineTouched?.[index]?.[field] && lineErrors?.[index]?.[field] ? lineErrors[index][field] : null;
  };

  const triggerPick = (index: number) => {
    if (NotEditable) return;
    document.getElementById(`file-${index}`)?.click();
  };

  const renderAttachmentCell = (line: any, index: number) => {
    const hasNewFile = line?.fileAttachment instanceof File;
    const hasExisting = !!line?.existingAttachment;

    return (
      <td className='align-middle text-center'>
        <input
          id={`file-${index}`}
          type='file'
          hidden
          disabled={NotEditable}
          // onChange={e => {
          //   const f = e.currentTarget.files?.[0] || null;
          //   if (!f) return;

          //   handleLineChange(index, 'fileAttachment', f);
          //   handleLineChange(index, 'existingAttachment', null);
          //   e.currentTarget.value = '';
          // }}

          onChange={e => {
            const f = e.currentTarget.files?.[0] || null;
            if (!f) return;
            // debugger;

            // ✅ تحقق الحجم
            if (f.size > MAX_FILE_SIZE_BYTES) {
              // امسح الاختيار
              e.currentTarget.value = '';
              ToastSwal({
                text: t(`حجم الملف كبير (${formatMB(f.size)}MB). الحد الأقصى ${MAX_FILE_SIZE_MB}MB`),
                icon: 'warning'
              });

              // لا تحفظ الملف
              handleLineChange(index, 'fileAttachment', null);

              setFieldTouched(`apExpenseLinesList[${index}].fileAttachment`, true, false);
              return;
            }

            // ✅ صالح: خزّن الملف وامسح خطأ سابق
            handleLineChange(index, 'fileAttachment', f);
            handleLineChange(index, 'existingAttachment', null);

            setFieldError(`apExpenseLinesList[${index}].fileAttachment`, undefined as any);

            // يسمح بإعادة اختيار نفس الملف
            e.currentTarget.value = '';
          }}
        />

        <div className='d-flex justify-content-center'>
          {hasNewFile ? (
            <div
              className='d-flex align-items-center bg-theme bg-opacity-10 text-theme px-2 py-1 rounded border border-theme border-opacity-25'
              style={{ maxWidth: '220px' }}
            >
              <i className='fas fa-file-alt me-2'></i>

              <OverlayTrigger overlay={<Tooltip>{line.fileAttachment.name}</Tooltip>}>
                <span
                  className='text-truncate small fw-bold flex-grow-1 cursor-pointer'
                  style={{ fontSize: '0.75rem' }}
                  onClick={() => triggerPick(index)}
                >
                  {line.fileAttachment.name}
                </span>
              </OverlayTrigger>

              {!NotEditable && (
                <button
                  type='button'
                  className='btn btn-link btn-sm text-danger p-0 ms-2'
                  onClick={() => handleLineChange(index, 'fileAttachment', null)}
                >
                  <i className='fas fa-times-circle'></i>
                </button>
              )}
            </div>
          ) : hasExisting ? (
            <div
              className='d-flex align-items-center bg-secondary bg-opacity-10 px-2 py-1 rounded border border-secondary border-opacity-25'
              style={{ maxWidth: '220px' }}
            >
              <i className='fas fa-paperclip me-2'></i>

              <a
                href={line.existingAttachment.filePath}
                target='_blank'
                rel='noreferrer'
                className='text-truncate small fw-bold flex-grow-1'
                style={{ fontSize: '0.75rem', textDecoration: 'none', color: 'inherit' }}
                title={line.existingAttachment.fileName}
              >
                {line.existingAttachment.fileName}
              </a>

              {!NotEditable && (
                <button type='button' className='btn btn-outline-theme btn-sm ms-2' onClick={() => triggerPick(index)}>
                  {t('استبدال')}
                </button>
              )}
            </div>
          ) : (
            <button
              type='button'
              className='btn btn-outline-theme btn-sm d-flex align-items-center gap-2 px-3'
              onClick={() => triggerPick(index)}
              disabled={NotEditable}
            >
              <i className='fas fa-paperclip'></i>
              {t('أرفق ملف')}
            </button>
          )}
        </div>
      </td>
    );
  };

  return (
    <Loading loading={loading} error={error} Type='Dots'>
      <div className='card-header d-flex justify-content-between align-items-center   bg-opacity-50 py-3'>
        <h6 className='mb-0 fw-bold '>
          <i className='fas fa-list-ol me-2 text-theme'></i>
          {t('تفاصيل بنود المصروفات')}
        </h6>

        <div className='d-flex gap-3 align-items-center flex-wrap'>
          <span className='badge bg-theme bg-opacity-10 text-theme border border-theme border-opacity-25 d-flex align-items-center px-3'>
            {t('عدد البنود')}: {(values.apExpenseLinesList || []).length}
          </span>

          {/* ✅ Select (3 خيارات) */}
          <div className='d-flex align-items-center gap-2'>
            <span className='small fw-bold text-muted'>{t('الضريبة')}:</span>
            <Form.Select
              size='sm'
              disabled={NotEditable}
              value={vatMode}
              onChange={e => {
                const next = e.target.value as VatMode;
                setVatMode(next);
                recalcAllLines(next);
              }}
              style={{ width: 190 }}
              className='border-theme border-opacity-25'
            >
              <option value='STANDARD15'>{t('قياسي 15%')}</option>
              <option value='ZERO0'>{t('صفري 0%')}</option>
              <option value='CUSTOM'>{t('مخصص')}</option>
            </Form.Select>
          </div>

          <button
            hidden={NotEditable}
            type='button'
            className='btn btn-theme btn-sm px-3 shadow-sm'
            onClick={() =>
              setFieldValue('apExpenseLinesList', [
                ...(values.apExpenseLinesList || []),
                {
                  id: '',
                  expenseCategoryItemId: '',
                  description: '',
                  amount: 0, // ✅ NET دائمًا للإرسال
                  vat: 0,
                  isIncludeVat: vatMode === 'STANDARD15',
                  existingAttachment: null,
                  fileAttachment: null
                }
              ])
            }
          >
            <i className='fas fa-plus-circle me-2'></i>
            {t('إضافة بند')}
          </button>
        </div>
      </div>

      {(values.apExpenseLinesList || []).length > 0 && (
        <div className='card-body p-3'>
          <div className='bg-inverse bg-opacity-10 p-3 rounded-0'>
            <div className='d-flex flex-wrap gap-4 justify-content-between'>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('الإجمالي')}:</span>
                <span className='fw-bold'>{totals.subtotal}</span>
              </div>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('الضريبة')}:</span>
                <span className='fw-bold text-warning'>{totals.vat}</span>
              </div>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('الصافي')}:</span>
                <span className='text-theme fs-5 fw-bold'>{totals.total}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className='card-body p-0'>
        {(values.apExpenseLinesList || []).length > 0 ? (
          <div className='table-responsive'>
            <div style={{ maxHeight: maxTableHeight, overflow: 'auto' }}>
              <table className='table table-hover align-middle mb-0'>
                <thead className='table-actived fw-bold sticky-top' style={{ zIndex: 10 }}>
                  <tr className='small text-muted'>
                    <th className='text-center' style={{ width: '50px' }}>
                      #
                    </th>
                    <th style={{ width: '20%' }}>{t('بند المصروف')}</th>
                    <th style={{ width: '35%' }}>{t('الوصف')}</th>
                    <th className='text-center' style={{ width: '12%' }}>
                      {vatMode === 'STANDARD15' ? t('القيمة (شامل)') : t('القيمة')}
                    </th>
                    <th className='text-center' style={{ width: '12%' }}>
                      {vatMode === 'CUSTOM' ? t('الضريبة (مخصص)') : t('الضريبة')}
                    </th>
                    <th className='text-center' style={{ width: '10%' }}>
                      {t('المرفق')}
                    </th>
                    <th className='text-center' style={{ width: '8%' }}></th>
                  </tr>
                </thead>

                <tbody>
                  {(values.apExpenseLinesList || []).map((line: any, index: number) => {
                    const hasError = !!getLineError(index, 'expenseCategoryItemId') || !!getLineError(index, 'amount');

                    // ✅ المخزن/المرسل دائمًا NET/VAT
                    const netAmount = toNum(line.amount);
                    const vatAmount = toNum(line.vat);
                    const grossAmount = round2(netAmount + vatAmount); // ✅ عرض فقط

                    return (
                      <tr key={line.rowKey || index} className={hasError ? 'bg-danger bg-opacity-10' : ''}>
                        <td className='text-center small fw-bold text-muted'>{index + 1}</td>

                        <td>
                          <Form.Select
                            disabled={NotEditable}
                            size='sm'
                            className={`border-theme border-opacity-25 ${
                              getLineError(index, 'expenseCategoryItemId') ? 'is-invalid' : ''
                            }`}
                            value={line.expenseCategoryItemId || ''}
                            onChange={e => handleLineChange(index, 'expenseCategoryItemId', e.target.value)}
                          >
                            <option value=''>{t('اختر البند...')}</option>
                            {data?.map((m: any) => (
                              <option value={m.id} key={m.id}>
                                {i18n.language === 'en' ? m.name : m.name2}
                              </option>
                            ))}
                          </Form.Select>
                        </td>

                        <td>
                          <Form.Control
                            disabled={NotEditable}
                            size='sm'
                            as='textarea'
                            rows={1}
                            className='border-theme border-opacity-25'
                            value={line.description || ''}
                            onChange={e => handleLineChange(index, 'description', e.target.value)}
                            style={{ minHeight: '35px' }}
                          />
                        </td>

                        {/* ✅ القيمة: في القياسي المستخدم يدخل شامل، في غيره NET */}
                        <td>
                          <NumericFormat
                            disabled={NotEditable}
                            value={vatMode === 'STANDARD15' ? grossAmount : netAmount}
                            thousandSeparator=','
                            className='form-control form-control-sm border-theme border-opacity-25 text-center fw-bold'
                            onValueChange={v => {
                              const input = v.floatValue || 0;
                              applyAmountInput(index, input);
                            }}
                          />
                        </td>

                        {/* ✅ الضريبة: مخصص => Editable ، غيره => ReadOnly */}
                        <td>
                          <NumericFormat
                            disabled={NotEditable || vatMode !== 'CUSTOM'}
                            value={vatAmount}
                            thousandSeparator=','
                            className='form-control form-control-sm border-theme border-opacity-25 text-center'
                            onValueChange={v => {
                              const vv = v.floatValue || 0;
                              applyVatInputCustom(index, vv);
                            }}
                          />
                        </td>

                        {renderAttachmentCell(line, index)}

                        <td className='text-center'>
                          <button
                            type='button'
                            className='btn btn-link btn-sm text-danger p-0'
                            onClick={() => handleDeleteLine(index)}
                            hidden={NotEditable}
                          >
                            <i className='fas fa-trash-alt'></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className='card-body p-5 text-center'>
            <div className='opacity-50 mb-3'>
              <i className='fas fa-receipt fa-4x text-theme'></i>
            </div>
            <h5 className='text-muted'>{t('لا توجد مصروفات بعد')}</h5>
            <p className='small text-muted mb-4'>{t('قم بإضافة البنود لتبدأ في تسجيل المصروفات')}</p>
          </div>
        )}
      </div>
    </Loading>
  );
};

export default ApExpenseLines;
